import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/configAutoCreateStudentCode',
    name: 'configAutoCreateStudentCode',
    component: () => import('@/views/admin/studentManagement/configAutoCreateStudentCode/ConfigAutoCreateStudentCode.vue'),
    meta: {
      pageTitle: 'Cấu hình tự động tạo mã sinh viên',
      breadcrumb: [
        {
          text: 'Hệ thống',
          active: false,
        },
        {
          text: 'Cấu hình tự động tạo mã sinh viên',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CONFIG_CREATE_STUDENT_CODE,
    },
  },
  {
    path: '/admin/config_register_subject',
    name: 'registerSubject',
    component: () => import('@/views/system/config_register_subject/Index.vue'),
    meta: {
      pageTitle: 'Cấu hình thời gian đăng ký học phần',
      breadcrumb: [
        {
          text: 'Hệ thống',
          active: true,
        },
        {
          text: 'Cấu hình thời gian đăng ký học phần',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.REGISTER_SUBJECT,
    },
  },
  {
    path: '/generalScore',
    name: 'generalScore',
    component: () => import('@/views/system/general-score/GeneralScore.vue'),
    meta: {
      pageTitle: 'Điểm chung',
      breadcrumb: [
        {
          text: 'Hệ thống',
          active: true,
        },
        {
          text: 'Điểm chung',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.GENERAL_SCORE,
    },
  },
]
